__webpack_require__.p = "https://mn.chatie.me/assets/7626a8354df70db9c3a4497ed83cecc371b34cb6/_next/";